var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.layout === 'common')?_c('div',[_c('Header')],1):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":_vm.layout + '_layout_wrapper'}},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }